import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  // 健康讲堂
  {
    path: '/lecture/homepage',
    component: () => import('@/pages/lecture/homepage'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
    },
    children: [
      // 文章详情
      {
        path: 'article',
        component: () => import('@/pages/lecture/article'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
        }
      },
      // 视频详情
      {
        path: 'video',
        component: () => import('@/pages/lecture/video'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
        }
      }
    ]
  }
];
